import React, { useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getIsBpVerified,
  getVerifyingBp,
  verifyBrokerAgainstProspect,
} from "../store/quotes";
import Loader3Orange from "./Loader3Orange";
import UnauthorizedAccess from "./UnauthorizedAccess";

const AuthBrokerProspect = (props) => {
  const { prospectid } = props;

  const isbpVerified = useSelector(getIsBpVerified);
  const verifyingBp = useSelector(getVerifyingBp);
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(
      verifyBrokerAgainstProspect({
        prospectid: prospectid,
      })
    );
  }, [dispatch, prospectid]);

  return (
    <React.Fragment>
      {verifyingBp ? (
        <div>
          <Loader3Orange></Loader3Orange>
        </div>
      ) : isbpVerified ? (
        props.children
      ) : (
        <UnauthorizedAccess></UnauthorizedAccess>
      )}
    </React.Fragment>
  );
};

export default AuthBrokerProspect;
